import { useState } from "react";
import { REWARDS_OPT_IN_URL } from "../conf";
import calcUserRewardPoints from "../utils/calcUserRewardPoints";
import useData from "./useData";
import useResource from "./useResource";

const useReward = () => {
	const {
		email = false,
		first_name = false,
		cost = false,
		identifier = false,
	} = useData();
	const [rewardData, setRewardData] = useState({
		email,
		first_name,
		earned_points: calcUserRewardPoints(cost),
		identifier,
	});

	const remoteActions = useResource(
		{
			url: REWARDS_OPT_IN_URL,
			data: rewardData,
			method: "POST",
		},
		false
	);

	return {
		setRewardData,
		remoteActions,
	};
};

export default useReward;
